export const FAILED_TO_FETCH_LOCIZE_RETRIES = 3;
export const FAILED_TO_FETCH_LOCIZE_RETRIES_DELAY_MS = 2000;

export const FAILED_TO_FETCH_LOCIZE_ERROR_STATUS = 0;
export const FAILED_TO_FETCH_LOCIZE_ERROR_MESSAGE = 'Failed to fetch';

export const LOCALLY_LOADED_NAMESPACES = ['common', 'hotline', 'legal'];

export const FAILED_TO_FETCH_LOCIZE_EXCEPTION_PREFIX = 'Locize error';
